import { Card } from '../../../components/Comunidade/Card';
import styles from './style.module.css';
import { useState } from 'react';

interface ICardData {
    title: string;
    link: string;
}

const Comunidade = () => {
    const [cardsData] = useState<ICardData[]>([
        { title: 'Comunidade', link: '/extranet/feagri/comunidade' },
        { title: 'Corpo Docente', link: '/extranet/feagri/comunidade/corpo-docente' },
        { title: 'Professor Colaborador', link: '/extranet/pesquisa/colaboradores/professor-colaborador' },
        { title: 'Pesquisador Colaborador', link: '/extranet/pesquisa/colaboradores/pesquisador-colaborador' },
        { title: 'Pesquisador de Pós-Doutorado', link: '/extranet/pesquisa/colaboradores/pos-doutorado' },
        { title: 'Funcionários', link: '/extranet/feagri/comunidade/funcionarios' },
        // { title: 'Estagiários', link: '/extranet/feagri/comunidade/funcionarios' },

    ]);


    return (
        <>

            <div className={styles.containerCards}>


                {cardsData.map((cardData, index) => {
                    return (
                        <Card title={cardData.title} key={index} link={cardData.link} index={index} />
                    );
                })}


            </div>
        </>
    );
}

export { Comunidade };